import AdminLayoutView from './view';

export default AdminLayoutView;
